import { Lightning } from "@lightningjs/sdk";
import { GlassSurface } from "../base/GlassSurface";
import { WATCH_GLASS, WATCH_PINK, WATCH_DARK, WATCH_PANEL_WIDTH, watchAsset, watchText, } from "./styles";
export class WatchScore extends Lightning.Component {
    static _template() {
        const score = (text) => (Object.assign(Object.assign({}, watchText(text, 140, 200, "BW Stretch")), { fontStyle: "700", h: 177.4, lineHeight: 177.4, 
            // Centre the visible capitals rather than the font's full em box.
            offsetY: 125.72 }));
        return {
            w: WATCH_PANEL_WIDTH,
            h: 343,
            Glass: {
                type: GlassSurface,
                w: WATCH_PANEL_WIDTH,
                h: 343,
                glassOptions: WATCH_GLASS,
            },
            Tint: {
                w: WATCH_PANEL_WIDTH,
                h: 343,
                rect: true,
                color: 0x33161616,
                shader: { type: Lightning.shaders.RoundedRectangle, radius: 24 },
            },
            HomeLogo: {
                x: 80,
                y: 62,
                w: 188.46,
                h: 188.46,
                texture: Lightning.Tools.getSvgTexture(watchAsset("psg.svg"), 377, 377),
            },
            AwayLogo: {
                x: 1079,
                y: 62,
                w: 188.46,
                h: 188.46,
                texture: Lightning.Tools.getSvgTexture(watchAsset("marseille.svg"), 377, 377),
            },
            HomeName: {
                x: 66.52,
                y: 250.69,
                text: watchText("PSG", 28.788, 214.38, "Roboto"),
            },
            AwayName: {
                x: 1066.56,
                y: 250.69,
                text: watchText("Marseille", 28.788, 214.38, "Roboto"),
            },
            Competition: {
                x: 602.5,
                y: 33,
                w: 142,
                h: 50,
                texture: Lightning.Tools.getSvgTexture(watchAsset("ligue-1-plus.svg"), 284, 100),
            },
            HomeScore: { x: 413.5, y: 83, text: score("2") },
            AwayScore: { x: 733.5, y: 83, text: score("1") },
            Divider: {
                x: 672.63,
                y: 83,
                w: 1.74,
                h: 177.397,
                texture: Lightning.Tools.getSvgTexture(watchAsset("divider.svg"), 4, 355),
            },
            Date: {
                x: 384,
                y: 260.4,
                text: watchText("22 OCTOBER", 32, 579),
            },
            Status: {
                x: 485,
                y: -25,
                w: 378,
                h: 50,
                Background: {
                    w: 378,
                    h: 50,
                    rect: true,
                    shader: {
                        type: Lightning.shaders.RoundedRectangle,
                        radius: 14,
                        fillColor: WATCH_PINK,
                        stroke: 1,
                        strokeColor: 0xffffffff,
                    },
                },
                Content: {
                    x: 189,
                    y: 25,
                    mount: 0.5,
                    flex: { direction: "row", alignItems: "center" },
                    LiveIcon: {
                        w: 14,
                        h: 14,
                        texture: Lightning.Tools.getSvgTexture(watchAsset("live.svg"), 28, 28),
                        flexItem: { marginRight: 6 },
                    },
                    Label: {
                        y: 4,
                        text: Object.assign(Object.assign({}, watchText("LIVE", 34, 0)), { textColor: WATCH_DARK }),
                    },
                },
            },
        };
    }
}
export default WatchScore;
//# sourceMappingURL=WatchScore.js.map